// Based on the settings selected from the modal od the Layer selected we return the appropriate map file, provide, space and time resoltuion

import LayersAndResolutions from 'data/layers/LayersAndResolutions.json';

function fileRecognize(buttonName, spaceResolution, timeResolution, predictionDay) { //Button name is the layer we want and the space and time resolution are the ones selected for the layer
    
    const layer = LayersAndResolutions.layers.find(l => l.longName === buttonName);
    console.log({
        fileName: layer.fileName,
        provider: layer.shortName,
        longName: buttonName,
        spaceResolution: spaceResolution,
        timeResolution: timeResolution,
        predictionDay: predictionDay
    })
    return {
        fileName: layer.fileName,
        provider: layer.shortName,
        longName: buttonName,
        spaceResolution: spaceResolution,
        timeResolution: timeResolution,
        predictionDay: predictionDay
    };

}

export default fileRecognize;

